export default {"src":"/_next/static/media/phone-moderate.eef1ad94.svg","height":77,"width":66};